import { PureComponent } from 'react';
import { circleIcon } from '../common/Icons';

interface Props {
    name: string;
    children: React.ReactNode;
}

class AdmitPatientDivContainer extends PureComponent<Props> {
    circleIcon = circleIcon();

    render() {
        const { name, children } = this.props;
        const { circleIcon } = this;

        return (
            <div className="bg-white">
                <div className="px-16 py-12 flex items-center space-x-16 border-b border-darwin-neutral_new-200">
                    <p>{circleIcon}</p>
                    <p className="text-16 font-700">{name}</p>
                </div>
                {children}
            </div>
        );
    }
}

export default AdmitPatientDivContainer;
